import dayjs from "dayjs";
import { zendeskWidgetUrl } from "@/constants/zendesk";
import { getRestrictedHelpCenterJwt } from "@/api/zendesk";

const lastAuthDateKey = "occ_lastAuthDate";

export const saveZendeskLastAuthDate = () => {
  localStorage.setItem(lastAuthDateKey, String(new Date()));
};

export const getZendeskLastAuthDate = () => {
  const lastAuthDate = localStorage.getItem(lastAuthDateKey);
  if (!lastAuthDate) {
    return undefined;
  }
  return new Date(lastAuthDate);
};

export const removeZendeskLastAuthDate = () => {
  localStorage.removeItem(lastAuthDateKey);
};

// 8時間以内はzendesk ssoを使ったzendeskへの自動ログインを行わないよう制御するためのメソッド。
// このメソッドではjwtの有効期限については考慮していない。
// 8時間以内にzendesk側の認証が切れた場合、zendeskのページにアクセスしようとした際にOCCのSSOコールバック経由でzendeskにログインして遷移先のページが表示されるため、挙動としては問題ない状態となっている。
export const requireZendeskReAuth = () => {
  // zendeskのssoは1分間に10回までという制限があるため、8時間は再認証をしないように制御
  const expirationHoursTerm = 8;

  const zendeskLastAuthDate = getZendeskLastAuthDate();
  if (!zendeskLastAuthDate) return true;

  const hoursDiff = dayjs().diff(dayjs(zendeskLastAuthDate), "hours");
  return hoursDiff > expirationHoursTerm;
};

export const createZESettings = (jwtToken: string): ZendeskSettings => ({
  webWidget: {
    position: { horizontal: "right", vertical: "bottom" },
    authenticate: {
      jwtFn: function(callback) {
        callback(jwtToken);
      }
    }
  }
});

export const removeZendeskToken = (): void => {
  window.zE && window.zE("webWidget", "logout");
};

export const setZendeskWidget = async (): Promise<void> => {
  if (window.zE) {
    window.zE("webWidget", "show");
  } else {
    require("@/assets/styles/zendesk.scss");
    const zendeskScript = document.createElement("script");
    zendeskScript.setAttribute("src", zendeskWidgetUrl);
    zendeskScript.setAttribute("Key", "zendesk");
    zendeskScript.setAttribute("id", "ze-snippet");
    document.head.appendChild(zendeskScript);
  }

  // setZendeskWidgetはアクセス直後 or ログイン直後にしか呼ばれないのでjwtを作りすぎるというケースは考えなくて良い
  try {
    let {
      data: { restricted_help_center_jwt }
    } = await getRestrictedHelpCenterJwt();
    restricted_help_center_jwt =
      restricted_help_center_jwt === null ? "" : restricted_help_center_jwt;
    window.zESettings = createZESettings(restricted_help_center_jwt);
  } catch (error) {
    throw error;
  }
};

export const resetZendeskWidget = (): void => {
  window.zE && window.zE("webWidget", "hide");
};
